import * as React from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import { Title } from 'react-admin';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Typography from '@mui/material/Typography';

import config from '../../config/config.json';

const hostQuizCandidato = config.production.hostQuizCandidato;

// Pagina raggiunta dai vecchi link "/resetpassword/<hash>" presenti nelle email di invito già inviate.
// Il reset ora si fa dal portale quiz con "Primo accesso o password dimenticata?": qui non si chiama il backend.
function ResetPasswordPage() {

    return (
        <Card sx={{ mt: 10, textAlign: 'center', backgroundColor: '#f3f6f9' }}>
            <Title title="Link non più valido" />

            <CardContent>
                <ErrorOutlineIcon sx={{ fontSize: 60, color: '#e85a2c' }} />
                <Typography variant="h4" sx={{ margin: '20px 0', color: '#e85a2c' }}>
                    SW KI FACTOR - Link non più valido
                </Typography>
                <Typography variant="subtitle1">
                    <hr></hr>
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                    Questo link per impostare la password non è più in uso.<br />
                    Vai alla pagina di accesso al quiz e clicca su <strong>"Primo accesso o password dimenticata?"</strong>:
                    riceverai via email un nuovo link.
                </Typography>
                <Button
                    variant="contained"
                    href={hostQuizCandidato}
                    sx={{ backgroundColor: '#e85a2c', '&:hover': { backgroundColor: 'gray' } }}
                >
                    Vai alla pagina di accesso al quiz
                </Button>
            </CardContent>
        </Card>
    );
}

export default ResetPasswordPage;
